"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
require("ngVue");
var RefundPurpose_vue_1 = __importDefault(require("./RefundPurpose.vue"));
var angular_1 = __importDefault(require("angular"));
var payment_html_1 = __importDefault(require("./payment.html"));
var payment_controller_1 = __importDefault(require("./payment.controller"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.crm.payment", {
        url: "/payment/:paymentId",
        template: payment_html_1.default,
        controller: payment_controller_1.default,
        controllerAs: "vm",
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.crm.payment", [])
    .directive("dcRefundPurpose", ["createVueComponent", function (createVueComponent) {
        return createVueComponent(vue_1.default.component("DcRefundPurpose", RefundPurpose_vue_1.default));
    }])
    .config(config)
    .controller("AdminPaymentController", payment_controller_1.default);
